import { REQUEST_HELP_CALL } from 'actions/helpCall'

export default (state = null, action) => {
    switch (action.type) {
        case REQUEST_HELP_CALL:
            if (!!action.error) {
                return action.payload
            } else {
                return action.payload.data;
            }
    }

    return state;
}